import { Component,ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { ViewWillEnter,IonContent  } from "@ionic/angular";
import { SystemSettingService } from '../../services/system-settings.service';
import { ToasterService } from "../../../../common/services/toaster.service";
import { RequestParams } from '../../../../common/rest-api/models/request-params';
@Component({
  selector: 'app-web-customer-product-page',
  templateUrl: 'web-customer-product.page.html',
  styleUrls: [
    './web-customer-product.page.scss',
  ]
})
export class WebCustomerProductPage implements ViewWillEnter{
  settingsFields:any[];
  systemSetting:any[];
   constructor(
        private systemSettingService: SystemSettingService,
            private toasterService: ToasterService,
            private router:Router
      ) { 
  
    }
  loading:boolean=true ;
  availableProducts:any;
     customerCode :string=""; 

  paymentMethods:any;

  orderTypes :any;


  ngOnInit() {
    this.loadData(); 
  }
  async ionViewWillEnter():Promise<void> {
    
  this.loadData();
}
 getCustomerProduct(){
  this.loadData();
 }
  async loadData() {
    this.loading=false;

   await this.systemSettingService.getCustomerProductDetail(this.customerCode).then((response) => {
        
         this.paymentMethods = response?.stPayMethod || [];
        this.orderTypes = response?.webOrderTypes || [];
        this.availableProducts = response?.availableProducts || {};

      });
      
        this.loading=true;

    }
  async saveCustSetting() {
        
        this.loading=false;
     const selectedPayMethods = this.paymentMethods
          .filter(pm => pm.isSelected)
          .map(pm => pm.methodCode);

      const selectedOrderTypes= this.orderTypes
          .filter(ot => ot.isSelected)
          .map(ot => ot.typeCode);
      await this.systemSettingService.saveCustomerSettings(this.customerCode,selectedPayMethods,selectedOrderTypes).then((response) => {
        if (response =='success') {
          this.toasterService.presentToast(
            "primary",
            " The Item was Updated Successfully! ",
            "Success"
          );
             this.loading=true;
        }else if (response =='notExist') {
          this.toasterService.presentToast(
            "danger",
            "Please enter valid Customer Code",
            "Error"
          );
             this.loading=true;
        }  
        else {
          this.toasterService.presentToast(
            "danger",
            `Error Updating Web Customer Setting.`,
            "Error"
          );  
             this.loading=true;
                }
    });
      this.loading=true;
      }
  editCustomerProduct(customerCode,productCode) {
      this.router.navigate(['admin-page/web-customer-product/edit/' + customerCode+'/'+productCode]);
    }
 webProductEdit(productCode,productType) {
      this.router.navigate(['/admin-page/web-product-admin/edit/' + productCode+'/'+productType+'/'+true]);
    }

}